import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import moment from 'moment';
import { eduNameAsyncValidate } from 'libs/validation';

import {
  ModalTemplate,
  Button,
  ReduxFormMaterialTextField,
  ReduxFormDatePicker,
  ReduxFormSemanticDropdown
} from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalEduEdit extends Component {
  constructor(props) {
    super(props);

    const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
    this.state = {
      startDate: moment(common.timeFormatFromUTCEpoch(props.selectEditEduData.get('startEpoch'), 3), dateFormat),
      endDate: moment(common.timeFormatFromUTCEpoch(props.selectEditEduData.get('endEpoch'), 3), dateFormat)
    };
  }

  handleDatePickerOnChangeStart = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(0)
      .minute(0)
      .second(0);

    const dateObj = {
      startDate: date
    };
    if (date > this.state.endDate) {
      // 시작 날짜를 종료 날짜 이후로 선택한 경우
      // 종료 날짜를 초기화 해준다.
      dateObj.endDate = null;
    }

    this.setState(dateObj);
  };

  handleDatePickerOnChangeEnd = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(23)
      .minute(59)
      .second(59);

    this.setState({
      endDate: date
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      visible,
      isClicked,
      onPutEdu,
      onToggleModal,
      selectEditEduNo,
      eduSummaryByEduNo,
      selectEditEduData,
      eduExamOrdering,
      eduExamByExamNo,
      examNoArray,
      handleChangeExam,
      formStoreEdit
    } = this.props;
    const { startDate, endDate } = this.state;

    if (!selectEditEduNo || !eduSummaryByEduNo.get(String(selectEditEduNo))) {
      return null;
    }

    const disabledStart = selectEditEduData.get('startEpoch') < common.nowEpoch() ? true : false;
    const disabledEnd = selectEditEduData.get('endEpoch') < common.nowEpoch() ? true : false;

    // 교육 기간
    let reserveEdu = '';
    let periodExam = '';

    if (formStoreEdit && formStoreEdit.values) {
      const startMoment = formStoreEdit.values.startEpoch ? moment(formStoreEdit.values.startEpoch) : moment(startDate);

      if (formStoreEdit.values.startEpoch && moment() < startMoment) {
        reserveEdu = defineMessages(formatMessage({ id: 'EduAdd_2', defaultMessage: '교육을 예약함' }));
      }

      if (
        formStoreEdit.values.endEpoch &&
        formStoreEdit.values.endEpoch > formStoreEdit.values.startEpoch + 86400 * 1
      ) {
        const endMoment = moment(formStoreEdit.values.endEpoch);
        periodExam =
          defineMessages(formatMessage({ id: 'EduAdd_3', defaultMessage: '교육 기간' })) +
          ': ' +
          moment.duration(endMoment.diff(startMoment)).humanize();
      }
    }

    // 전체 훈련
    const eduExamOption = [];

    eduExamOrdering.map(examNo => {
      const examItem = eduExamByExamNo.get(String(examNo));

      eduExamOption.push({
        key: examItem.get('examNo'),
        value: examItem.get('examNo'),
        text: examItem.get('examName')
      });
    });

    const eduEditComponent = (
      <div className={cx('modal-content', 'edu-edit-modal')}>
        <div className={cx('modalTargetAdd-wrapper')}>
          <div className={cx('wrapper-inner')}>
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'Edu_1', defaultMessage: '교육명' }))} *
            </span>
            <ReduxFormMaterialTextField
              className={cx('materialTextfield', 'input-area')}
              name="eduName"
              checkType={101}
              required
              validate={['required', 'examName']}
            />
          </div>
          <div className={cx('date-area')}>
            <div className={cx('date-input')}>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'ModalExamEdit_5', defaultMessage: '시작일자' }))} *
              </span>
              {!!disabledStart ? (
                <div>
                  <div className={cx('disabled-date')}>
                    <div className={cx('content')}>
                      {common.timeFormatFromUTCEpoch(selectEditEduData.get('startEpoch'), 3)}
                    </div>
                  </div>
                </div>
              ) : (
                <ReduxFormDatePicker
                  defaultValue={moment(startDate)}
                  helperText={reserveEdu}
                  helperTextClassName="end-date-detail"
                  className={cx('date-input')}
                  name="startEpoch"
                  locale={localStorage.getItem('language')}
                  todayButton="Today"
                  shouldCloseOnSelect //={false}
                  selectsStart
                  showYearDropdown
                  dropdownMode="select"
                  showMonthDropdown
                  dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                  startDate={this.state.startDate}
                  minDate={moment()}
                  maxDate={moment('2037-11-30')}
                  endDate={this.state.endDate}
                  onChange={this.handleDatePickerOnChangeStart}
                  checkType={100}
                  validate={['dateRequired', 'reduxFormDatePicker']}
                  error={
                    formStoreEdit &&
                    formStoreEdit.values &&
                    formStoreEdit.values.startEpoch &&
                    !!!formStoreEdit.values.startEpoch
                  }
                />
              )}
            </div>
            <div className={cx('date-input')}>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'ModalExamEdit_6', defaultMessage: '종료일자' }))} *
              </span>
              {!!disabledEnd ? (
                <div className={cx('disabled-date')}>
                  <div className={cx('content')}>
                    {common.timeFormatFromUTCEpoch(selectEditEduData.get('endEpoch'), 3)}
                  </div>
                </div>
              ) : (
                <ReduxFormDatePicker
                  defaultValue={moment(endDate)}
                  helperText={periodExam}
                  helperTextClassName="end-date-detail"
                  className={cx('date-input')}
                  name="endEpoch"
                  locale={localStorage.getItem('language')}
                  todayButton="Today"
                  shouldCloseOnSelect //={false}
                  selectsEnd
                  showYearDropdown
                  dropdownMode="select"
                  showMonthDropdown
                  dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                  startDate={moment(this.state.startDate).add(1, 'd')}
                  minDate={moment(this.state.startDate).add(1, 'd')}
                  maxDate={moment('2037-12-31')}
                  endDate={moment(this.state.endDate)}
                  onChange={this.handleDatePickerOnChangeEnd}
                  checkType={101}
                  validate={['dateRequired', 'reduxFormDatePicker']}
                  error={
                    formStoreEdit &&
                    formStoreEdit.values &&
                    formStoreEdit.fields &&
                    formStoreEdit.fields['endEpoch'] &&
                    formStoreEdit.fields['endEpoch'].visited &&
                    (formStoreEdit.fields['endEpoch'].visited && formStoreEdit.values.endEpoch === null)
                  }
                  errorMessage={formStoreEdit && formStoreEdit.syncErrors}
                />
              )}
            </div>
          </div>
          <div className={cx('wrapper-inner')}>
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'Edu_10', defaultMessage: '연결훈련' }))}
            </span>
            <div className={cx('input-area-mt')}>
              <ReduxFormSemanticDropdown
                className={cx('eduExam-dropdown')}
                placeholder={
                  !!!examNoArray.get(String(selectEditEduNo)) ||
                  (formStoreEdit &&
                    formStoreEdit.values &&
                    formStoreEdit.values.examNoArray &&
                    formStoreEdit.values.examNoArray.length === 0)
                    ? defineMessages(
                        formatMessage({ id: 'Edu_11', defaultMessage: '교육과 연결시킬 훈련을 선택하세요' })
                      )
                    : ''
                }
                name="examNoArray"
                fluid
                multiple
                search
                selection
                autoFocus
                disabled={disabledEnd}
                options={eduExamOption}
                onChange={handleChangeExam}
                defaultValue={examNoArray.get(String(selectEditEduNo))}
              />
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-examEdit-area', 'common-content')}
        visible={visible}
        header={
          <div>
            {defineMessages(formatMessage({ id: 'EduEdit_1', defaultMessage: '교육 수정' }))}
            <span> {'(No.' + selectEditEduNo + ')'}</span>
          </div>
        }
        onToggleModal={onToggleModal}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalEdu_1', defaultMessage: '취 소' }))}
            </Button>
            <Button
              className={cx('gray-button')}
              disabled={isClicked}
              loading={isClicked}
              onClick={e => {
                //e.stopPropagation();
                onPutEdu(selectEditEduNo);
              }}>
              {defineMessages(formatMessage({ id: 'ModalEdu_3', defaultMessage: '수 정' }))}
            </Button>
          </div>
        }>
        {eduEditComponent}
      </ModalTemplate>
    );
  }
}

ModalEduEdit.propTypes = {
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, { selectEditEduNo, eduSummaryByEduNo, examNoArray }) => {
  return {
    initialValues: {
      eduNo: eduSummaryByEduNo.get(String(selectEditEduNo)).get('eduNo'),
      eduName: eduSummaryByEduNo.get(String(selectEditEduNo)).get('eduName'),
      examNoArray: examNoArray.get(String(selectEditEduNo))
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formEduEdit',
    asyncValidate: eduNameAsyncValidate,
    enableReinitialize: true,
    asyncBlurFields: ['eduName'],
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함,
  })(injectIntl(ModalEduEdit))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalEduEdit.js